'use client';
import React from 'react';

const brands = [
  { name: 'Creators', icon: '🎨' },
  { name: 'Brands', icon: '🏷️' },
  { name: 'Agencies', icon: '🏢' },
  { name: 'Marketers', icon: '📊' },
  { name: 'Founders', icon: '🚀' },
  { name: 'Studios', icon: '🎬' },
];

export default function TrustBar() {
  return (
    <section className="relative bg-[#080810] border-y border-white/5 py-10 overflow-hidden">
      {/* Gradient fades on sides */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#080810] to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#080810] to-transparent z-10 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-center font-sans text-xs text-white/25 tracking-[0.3em] uppercase mb-8">
          Used by creators, brands &amp; agencies worldwide
        </p>

        <div className="flex items-center justify-center gap-8 md:gap-16 flex-wrap">
          {brands?.map((brand) => (
            <div
              key={brand?.name}
              className="flex items-center gap-2.5 group cursor-default"
            >
              <span className="text-lg opacity-60 group-hover:opacity-100 transition-opacity duration-300">{brand?.icon}</span>
              <span className="font-sans text-sm font-medium text-white/30 group-hover:text-white/60 tracking-wide transition-colors duration-300">
                {brand?.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
